// utils/multiCar.utils.ts
import { toast } from "react-toastify";
import { MultiCarItem, OrderItem } from "../../home/components/types";

/** Create a new car */
export const createCar = (carNumber: string): MultiCarItem => ({
  carNumber: carNumber.trim(),
  productDetails: [],
  totalPrice: 0,
});

/** Remove a product from a car */
export const removeProduct = (car: MultiCarItem, productToDelete: { product: string; price: string } | null): MultiCarItem | null => {
  if (!productToDelete) return null; // means remove entire car

  const updatedProducts = car.productDetails.filter((p) => p.product !== productToDelete.product);

  const updatedTotalPrice = car.totalPrice - parseFloat(productToDelete.price);

  if (updatedProducts.length === 0) return null; // car becomes empty → remove it

  return {
    ...car,
    productDetails: updatedProducts,
    totalPrice: Math.max(updatedTotalPrice, 0),
  };
};

/** Add product to a car */
export const addProduct = (car: MultiCarItem, product: OrderItem): MultiCarItem | null => {
  const productExists = car.productDetails.some((p) => p.product === product.ProductName);

  if (productExists) {
    toast.error("Product already added to this car.");
    return null;
  }

  return {
    ...car,
    productDetails: [...car.productDetails, { product: product.ProductName, price: product.Amount }],
    totalPrice: car.totalPrice + parseFloat(product.Amount),
  };
};
